// DocumentoEntradaPDF.jsx
import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: "Helvetica",
  },
  title: {
    fontSize: 16,
    marginBottom: 12,
    textAlign: "center",
    fontWeight: "bold",
  },
  section: {
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: 10,
    marginBottom: 12,
  },
  row: {
    flexDirection: "row",
    marginBottom: 5,
  },
  label: {
    width: "30%",
    fontWeight: "bold",
  },
  value: {
    width: "70%",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#eee",
    borderBottom: "1px solid #999",
    padding: 5,
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1px solid #ddd",
    padding: 5,
  },
  colN: {
    width: "8%",
  },
  colEquipo: {
    width: "42%",
  },
  colSerie: {
    width: "25%",
  },
  colPrecio: {
    width: "25%",
    textAlign: "right",
  },
});

const DocumentoEntradaPDF = ({
  numDoc,
  nomTipDoc,
  date,
  nomTipoIn,
  rut,
  entidad,
  descripcion,
  dataEntrada,
}) => {
  const total = dataEntrada.reduce(
    (acc, item) => acc + Number(item.price || 0),
    0
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>Documento de Entrada de Equipos</Text>

        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.label}>Tipo Documento:</Text>
            <Text style={styles.value}>{nomTipDoc}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>N° Documento:</Text>
            <Text style={styles.value}>{numDoc}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Fecha:</Text>
            <Text style={styles.value}>{date}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Tipo Entrada:</Text>
            <Text style={styles.value}>{nomTipoIn}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Proveedor:</Text>
            <Text style={styles.value}>
              {rut} - {entidad}
            </Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Descripción:</Text>
            <Text style={styles.value}>{descripcion || "Sin descripción"}</Text>
          </View>
        </View>

        <View style={styles.section}>
          <Text style={{ marginBottom: 8, fontSize: 12 }}>
            Detalle de Equipos
          </Text>

          <View style={styles.tableHeader}>
            <Text style={styles.colN}>N°</Text>
            <Text style={styles.colEquipo}>Equipo</Text>
            <Text style={styles.colSerie}>Serie</Text>
            <Text style={styles.colPrecio}>Precio</Text>
          </View>

          {dataEntrada.map((item, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={styles.colN}>{index + 1}</Text>
              <Text style={styles.colEquipo}>
                {item.tipo} - {item.marca} - {item.modelo}
              </Text>
              <Text style={styles.colSerie}>{item.serie}</Text>
              <Text style={styles.colPrecio}>
                ${Number(item.price || 0).toLocaleString("es-CL")}
              </Text>
            </View>
          ))}

          <View style={[styles.tableRow, { marginTop: 8 }]}>
            <Text style={{ width: "75%", textAlign: "right" }}>Total:</Text>
            <Text style={styles.colPrecio}>
              ${total.toLocaleString("es-CL")}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default DocumentoEntradaPDF;